import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function IncludedSection() {
  const {
    t
  } = useLanguage();
  const inclusions = [{
    title: t('included.i1Title'),
    desc: t('included.i1Desc')
  }, {
    title: t('included.i2Title'),
    desc: t('included.i2Desc')
  }, {
    title: t('included.i3Title'),
    desc: t('included.i3Desc')
  }, {
    title: t('included.i4Title'),
    desc: t('included.i4Desc')
  }, {
    title: t('included.i5Title'),
    desc: t('included.i5Desc')
  }, {
    title: t('included.i6Title'),
    desc: t('included.i6Desc')
  }, {
    title: t('included.i7Title'),
    desc: t('included.i7Desc')
  }];
  return <section className="py-20 lg:py-28 bg-brand-cream" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-232">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-brand-black mb-6" data-id="element-233">
            {t('included.title')}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-text/80" data-id="element-234">
            {t('included.desc')}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-235">
          {inclusions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white p-6 rounded-xl border border-black/5 shadow-sm flex items-start gap-4 ${index === inclusions.length - 1 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-236">
              <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-237" />
              <div data-id="element-238">
                <h4 className="font-bold text-brand-black text-lg mb-1" data-id="element-239">
                  {item.title}
                </h4>
                <p className="text-brand-text/70 text-sm leading-relaxed" data-id="element-240">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}